<template>
    <v-form :ref="idForm">
      <v-row class="pt-5 pb-3 px-4">
        <v-col
          class="px-2 py-0"
          cols="4"
          v-for="(item, ind) in campos"
          :key="ind"
        >
          <label>{{ item.Nome }}</label>
          <v-text-field
            v-model="item.Valor"
            class="my-0"
            v-if="!item['Dominio']"
            outlined
            dense
            :rules="[requerido(item.Nome) ? formRules.requiredField : true]"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-form>
</template>
<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      campos: [],
      dadosExtrasPorTipo: [],
    };
  },
  computed: {
    ...mapState({
      formRules: (state) => state.formRules,
    }),
  },
  watch: {
    dialog: {
      deep: true,
      handler(val) {
        if (val) {
          this.campos = this.formDataPre.Dados[this.tipo].campo;
          this.$nextTick();
        } else {
          this.campos = [];
        }
      },
    },
    validarFormulario:{
      deep: false,
      handler(val) {
        console.log('watch', val)
        if (val) {
          this.validar();
        }
      }
    }
  },
  mounted() {
    this.campos = this.formDataPre.Dados[this.tipo].campo;
    this.$nextTick();
  },
  methods: {
    requerido(nome) {
      let requerido = this.dadosExtrasConfig[this.tipo].campo.filter(
        (ele) => {
          return ele.Nome.toUpperCase() == nome && Number(ele.Requerido) == 1;
        }
      ).length;

      return requerido;
    },
    validar() {
      if (this.$refs[this.idForm].validate()) {
        this.retornoForm(true);
      } else {
        this.retornoForm(false);
      }
    },
  },
  props: {
    dialog: Boolean,
    itemSelecionado: Object,
    tipo: String,
    dadosExtrasConfig: Object,
    grupoEconomico: Number,
    retornoForm: Function,
    formDataPre: Object,
    validarFormulario: Boolean,
    idForm: {
      type:String,
      default: "Recurso"
    }
  },
};
</script>

<style>
</style>